/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-25 11:56:52
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-25 14:21:01
 */
const change = function(key, val) {
  this.$Bus.$emit('requiredItemChange', {[key]: val});
}
export default {
  data() {
    return {
      isModified: false
    }
  },
  watch: {
    formData: {
      handler() {
        this.isModified = true;
      },
      deep: true
    }
  },
  methods: {
    change
  }
}

export const itemChange = {
  methods: {
    change
  }
}